import axios from 'axios';

import { getGraphBaseURL } from 'utils/apiUtils';

export const getNow = () => axios(`${getGraphBaseURL()}/now?t=${Date.now()}`);
